import { OfflineMsg } from "../models/api/OfflineMsg";
import { OfflineMsgType } from "../models/api/OfflineMsgType";
import { CryptoMsg } from "../models/app/CryptoMsg";
import { IMChat } from "../models/api/IMChat";
import { MqttBroadcast } from "../models/app/MqttBroadcast";
import { MqttMsg } from "../models/app/MqttMsg";
import { MqttMsgType } from "../models/app/MqttMsgType";
import { appConfig } from "../models/constants";
import ApiService from "./ApiService";
import AppCrypto from "./CryptoService";
import DbService, { DbServiceBase } from "./DbService";
import { IMChatSubscriptionService } from "./IMChatSubscriptionService";
import MqttService from "./MqttService";
import PubKeyManagerService from "./PubKeyManagerService";

class IMChatService{

    
    constructor(){
    }

    joinChat(chatId:string){
    }

    closeChat(chatId: string){
    }

    async sendOnlineChat(chat: IMChat){
        let recepId = chat.recepUid
        let pubKey = DbService.getPubKeyForChat(recepId)
        if(!pubKey)
         throw Error('Public Key not found')

        const data = await AppCrypto.encrypt(JSON.stringify(chat), pubKey)
        const msg: MqttMsg<CryptoMsg> = {
            type: MqttMsgType.CHAT,
            data: data
        }
        MqttService.publish(this.createTopic(recepId), JSON.stringify(msg))
    }

    async sendOfflineChat(chat: IMChat){

        if(!PubKeyManagerService.checkPubKey(chat.recepUid))
         return false

        let OfflineMsg: OfflineMsg = {
            type: 'CHAT',
            data: chat
        }

        ApiService.sendOfflineMsg(OfflineMsg)
    }

    handleIMChat(msg:IMChat){
        // console.log('Subscriptions '+IMChatSubscriptionService.subscriptions.size)
        // const callBack = IMChatSubscriptionService.subscriptions.get(msg.chatId)
        // if(callBack)
        //  callBack(msg)
        IMChatSubscriptionService.Instance.handleMsg(msg)
    }

    handleIMStatus(status: MqttBroadcast){
        IMChatSubscriptionService.Instance.handleStatusUpdate(status)
    }


    private createTopic(recepId: string){

        return `${appConfig.MQTT_BASE}/${appConfig.MQTT_PRIVATE}/${recepId}/${appConfig.MQTT_CHAT}`

    }

}

export default new IMChatService()